import React from "react"
import { graphql, Link } from "gatsby"
import TwoCol from "gatsby-theme-wirehead-bulma/src/twocol"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"

const PostLink = ({ post }) => {
  return (
    <li><Link to={post.node.path} key={post.node.path}>
      {post.node.context.title}
    </Link></li>
  )
}

const PhotoPage = ({
  data: {
    photos: { photoEdges },
    hierarchy: { hierarchyEdges },
  },
  pageContext,
  location,
}) => {
  const Galleries = hierarchyEdges.map(edge => {
    return <PostLink key={edge.node.path} post={edge} />
  })

  const Photos = photoEdges.map(edge => {
    return (
      <div className="card mbox">
      <div className="card-image">
      <figure className="image">
      <Link to={"/" + edge.node.slug} key={edge.node.slug}><img srcSet={edge.node.image.srcSet} alt={edge.node.frontmatter.title}/></Link>
      </figure>
      </div>
      <div class="card-content">
      <Link to={"/" + edge.node.slug} key={edge.node.slug}>{edge.node.frontmatter.title}</Link>
      </div>
      </div>
    );
  })

  return (<Layout>
    <SEO title={pageContext.title} />
    <section className="section">
    <TwoCol
        left={
          <div className="content">
            <h1 className="title">Recent sculptures:</h1>
            <div>
            {Photos}
            </div>
          </div>
        }
        right={
          <aside className="menu">
          </aside>
        }
      />
    </section>
  </Layout>);
}

export default PhotoPage

export const pageQuery = graphql`
  {
    photos: allMdx(
      filter: {frontmatter: {type: {eq: "Photo"}}, slug: {regex: "^/sculpt\\/.*/"}}
      limit: 10
      sort: {order: DESC, fields: frontmatter___date}
    ) {
      photoEdges: edges {
        node {
          id
          slug
          frontmatter {
            title
          }
          image {
            id
            key
            maxSize
            size
            srcSet
            srcPath
            width
            height
            sqSrcSet
            srcSet
            thumbnails {
              m {
                height
                width
                file
              }
            }
          }
        }
      }
    }
    hierarchy:allSitePage(
      sort: { fields: context___date, order: DESC }
      filter: { context: { date: {ne: null}, parent: { eq: "/sculpt" } } }
    ) {
      hierarchyEdges:edges {
        node {
          id
          path
          context {
            id
            name
            parent
            title
            type
            depth
            date
            excerpt
          }
        }
      }
    }
  }
`


export const frontmatter = {
  title: "Sculptures",
}